<template>
  <div class="sp-layout-col" part="base" :class="classModifiers">
    <div v-if="showLabel" class="label">{{ label }}</div>
    <div class="wrapper" part="wrapper">
      <slot ref="root" />
    </div>
  </div>
</template>

<script>
import { col as componentProps } from "./props";
</script>

<script setup>
import { toBoolean } from "../../utils/props";
import { useCol } from "./composables/use-col";
import { computed, ref } from "vue";

const root = ref(null);
useCol(root);

const props = defineProps({
  ...componentProps,
  foreground: {
    type: [Boolean, String],
    default: undefined,
  },
  label: {
    type: String,
    default: undefined,
  },
  showLabel: {
    type: [Boolean, String],
    default: false,
  },
});

const showLabel = computed(() => toBoolean(props.showLabel));

const classModifiers = computed(() => ({
  "--foreground": toBoolean(props.foreground),
}));
</script>

<style lang="scss">
@import "./styles/col";

.sp-layout-col {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  position: relative;

  .label {
    --color: hsla(0, 100%, 50%, 0.5);
    position: absolute;
    top: 0;
    right: 0;
    background: var(--color);
    border: 1px solid var(--color);
    color: white;
    line-height: 1;
    font-size: small;
    z-index: 999;
  }

  .wrapper {
    flex: 1 1 0;
    background: var(--sp-comp-layout-col-background);
    outline: var(--sp-comp-layout-col-outline);
    display: flex;
    flex-direction: column;
  }

  &.--foreground {
    .wrapper {
      z-index: var(--sp-comp-layout-col-foreground-z-index, 4);
      position: absolute;
      bottom: var(--sp-comp-layout-col-foreground-bottom, 0);
      top: var(--sp-comp-layout-col-foreground-top, auto);
      width: calc(100% - var(--column-gap-start) - var(--column-gap-end));
    }
  }
}
</style>
